import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoPoliticaCookie from "../legal/InfoPoliticaCookie";
const Footer = lazy(() => import('../footer/Footer'));
function PoliticaCookie() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="En Hyundai nos preocupamos por tu seguridad."
        />
        <meta name="keywords" content="politica, calidad, Hyundai" />
        <title>Politica de Calidad | Hyundai</title>
      </Helmet>
      <Menu />
      <InfoPoliticaCookie />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default PoliticaCookie;